<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12 ">
        <div class="card h-100 mt-3">
          <div class="card-header mb-0">
            <div class="row no-gutters">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <h5>{{ $t('content.mqrbill') }}</h5>
              </div>
            </div>

          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-lg-3">
								<label class="form-label ms-0">{{ $t("content.sdate") }}</label>
								<VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
									:max-date="new Date()" :enable-time-picker="false" month-name-format="long"
									:clearable="false" :text-input="textInputOptions" fluid />
							</div>

							<div class="col-lg-3">
								<label class="form-label ms-0">{{ $t("content.edate") }}</label>
								<VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
									:max-date="new Date()" :enable-time-picker="false" month-name-format="long"
									:clearable="false" :text-input="textInputOptions" fluid />
							</div>

              <div class="col-lg-6">
								<label class="form-label ms-0">{{ $t("content.names") }}</label>
								<div class="input-group">
									<input v-model="cusName_search" type="text" class="form-control"
										aria-describedby="searchName" readonly />
									<button class="btn btn-primary" type="button" @click="openDialogCus">
										<i class="material-icons material-symbols-outlined">search</i>
									</button>
									<button id="searchNameCus" class="btn btn-primary" type="button"
										data-bs-toggle="modal" data-bs-target="#searchNameModal" v-show="false">
									</button>
								</div>
							</div>

              <div class="col-lg-3">
                <label class="form-label ms-0">{{ $t("content.amnchannel") }}</label>
                  <select v-model="channel_search" class="form-select" @change="tx_search = ''; transfer_search = '';">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option value="SHOP">{{ $t('content.gchshop') }}</option>
                      <option value="LINE_LIFF">Line OA</option>
                  </select>
              </div>

              <div class="col-lg-3">
                <label class="form-label ms-0">{{ $t("content.transstatus") }}</label>
                  <select v-model="tx_search" class="form-select" :disabled="channel_search !== 'SHOP'">
                    <option value="">{{ $t('content.optall') }}</option>
                    <option value="INITIALIZED">สร้างรายการ</option>
                    <option value="WAITING_FOR_PAYMENT">รอชำระเงิน</option>
                    <option value="PAYMENT_RECEIVED">ชำระเงินแล้ว</option>
                    <option value="IN_PROGRESS">กำลังดำเนินการ</option>
                    <option value="COMPLETED">สำเร็จ</option>
                    <option value="INCOMPLETE">ไม่สำเร็จ</option>
                    <option value="CANCELLED">ยกเลิก</option>
                  </select>
              </div>

              <div class="col-lg-3">
                <label class="form-label ms-0">{{ $t("content.transferstatus") }}</label>
                  <select v-model="transfer_search" class="form-select" :disabled="channel_search !== 'SHOP'">
                    <option value="">{{ $t('content.optall') }}</option>
                    <option value="INITIAL">เริ่มต้น</option>
                    <option value="IN_PROCESS">กำลังดำเนินการ</option>
                    <option value="COMPLETE">สำเร็จ</option>
                    <option value="FAILURE">ล้มเหลว</option>
                    <option value="CANCEL">ยกเลิก</option>
                  </select>
              </div>

            </div>
            <div class="row mt-4">
							<div class="col-3 d-flex justify-content-between align-items-center"></div>
							<div class="col-9 d-flex justify-content-end align-items-center">
								<div class="me-3">
									<material-button id="cardSearch" color="primary"
										class="float-lg-start float-sm-end mb-3" :disabled="start_date > end_date || channel_search === ''"
										@click="checkChanel">
										<i class="material-icons material-symbols-outlined">search</i>
										{{ $t("buttons.sear") }}
									</material-button>
								</div>
								<div class="me-3">
									<material-button id="cardSearch" color="danger"
										class="float-lg-start float-sm-end mb-3" @click="cancelBtn">
										<i class="material-icons material-symbols-outlined">close</i>
										{{ $t("buttons.canc") }}
									</material-button>
								</div>
							</div>
						</div>
            <hr />
            <div class="row">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th class="align-top">#</th>
                      <th class="align-top text-center">{{ $t('content.date') }}</th>
                      <th class="align-top">{{ $t("content.names") }}</th>
                      <th class="align-top">{{ $t('content.jouneyref') }} 1</th>
                      <th class="align-top text-center" style="background-color:#dfffdd;">
                        <span style="color:black;">
                          {{ $t('content.infofbank') }}
                        </span>
                      </th>
                      <th colspan="2" class="align-top text-center" style="background-color:#CFEBFD;">
                        <span style="color:black;">
                          {{ $t('content.infofsystem') }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="width: 200px;">{{ $t('content.qrinfo') }}</th>
                      <th class="align-top text-center">{{ $t('content.act') }}</th>
                    </tr>
                    <tr>
                      <th colspan="4" class="align-top text-center"></th>
                      <th class="align-top text-center" style="background-color:#dfffdd;">
                         <span style="color:black;">
                          {{ $t("content.transferstatus") }}
                         </span>
											</th>
                      <th class="align-top text-center" style="background-color:#CFEBFD;">
                         <span style="color:black;">
                          {{ $t("content.transstatus") }}
                         </span>
											</th>
                      <th class="align-top text-center" style="background-color:#CFEBFD;">
                        <span style="color:black;">
                          {{ $t("content.transferstatus") }}
                        </span>
											</th>
                      <th colspan="2" class="align-top text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in listoc" :key="index" :class="row.paySide == 'PAY' ? 'bg-payment' : 'bg-receive'">
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        {{ format_datetime(row.createDate ) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.cusName }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.uid }}
                      </td>
                       <td class="text-sm font-weight-normal text-center">
                        <span v-if="channel_select === 'SHOP'">
                          <material-button color="info" variant="outline" class="rounded-circle"
                            :title="t('buttons.seed')" @click="receivableInfo(row,'view')" :disabled="row.receivableUid === '0'">
                            <i class="material-icons material-symbols-outlined">search</i>
                          </material-button>
                          <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                                  data-bs-toggle="modal" data-bs-target="#reciveInfoModal" id="detailModal">
                          </material-button>
                        </span>
                        <span v-else>
                          <span v-if="row.transferStatus === 'INITIAL'">เริ่มต้น</span>
                          <span v-else-if="row.transferStatus === 'IN_PROCESS'">กำลังดำเนินการ</span>
                          <span v-else-if="row.transferStatus === 'COMPLETE'">สำเร็จ</span>
                          <span v-else-if="row.transferStatus === 'FAILURE'">ล้มเหลว</span>
                          <span v-else-if="row.transferStatus === 'CANCEL'">ยกเลิก</span>
                          <span v-else>{{ row.transferStatus }}</span>
                        </span>
                        
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        <span v-if="row.txState === 'INITIALIZED'">สร้างรายการ</span>
                        <span v-else-if="row.txState === 'WAITING_FOR_PAYMENT'">รอชำระเงิน</span>
                        <span v-else-if="row.txState === 'PAYMENT_RECEIVED'">ชำระเงินแล้ว</span>
                        <span v-else-if="row.txState === 'IN_PROGRESS'">กำลังดำเนินการ</span>
                        <span v-else-if="row.txState === 'COMPLETED'">สำเร็จ</span>
                        <span v-else-if="row.txState === 'INCOMPLETE'">ไม่สำเร็จ</span>
                        <span v-else-if="row.txState === 'CANCELLED'">ยกเลิก</span> 
                        <span v-else>{{ row.txState }}</span>
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        <span v-if="row.transferStatus === 'INITIAL'">เริ่มต้น</span>
                        <span v-else-if="row.transferStatus === 'IN_PROCESS'">กำลังดำเนินการ</span>
                        <span v-else-if="row.transferStatus === 'COMPLETE'">สำเร็จ</span>
                        <span v-else-if="row.transferStatus === 'FAILURE'">ล้มเหลว</span>
                        <span v-else-if="row.transferStatus === 'CANCEL'">ยกเลิก</span>
                        <span v-else>{{ row.transferStatus }}</span>
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.qrCode }}
                      </td>
                       <!-- :disabled="row.receivableUid === '0'" -->
                      <td class="text-sm font-weight-normal">
                        <material-button  color="info" variant="outline" class="rounded-circle ms-1"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnApprove"
                          @click="receivableInfo(row,'approve')" disabled>
                          <i class="material-icons material-symbols-outlined">done_all</i>
                        </material-button>
                        <!-- v-if="channel_select === 'LINE_LIFF' && row.transferStatus !== 'COMPLETE'" -->
                        <material-button v-show="false"
                          color="danger" variant="outline" class="rounded-circle" 
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnDel" @click="deleteRowItems(row)">
                          <i class="material-icons material-symbols-outlined">close</i>
                        </material-button>
                      </td>
                    </tr>
                    <tr v-if="listoc.length === 0">
                      <td colspan="10" class="text-sm font-weight-normal">
                        <p style="text-align: center">No Record Found</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="15" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <pre></pre>
            <div style="display: flex; justify-content: flex-end">
              <ul v-show="listoc.length > 0" class="pagination justify-content-end">
                <div class="project-container">
                  <div class="example-one">
                    <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                      @click="onClickHandler" />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>

        <!-- Search Customer Dialog -->
				<div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
					aria-hidden="true">
					<div class="modal-dialog modal-dialog-centered">
						<div class="modal-content">
							<div class="modal-header">
								<h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
								<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
									id="closeModal">
									<i class="material-icons material-symbols-outlined">close</i>
								</button>
							</div>

							<div class="modal-body">
								<div class="preview-table">
									<section class="panel">
										<table class="table table-striped table-responsive">
											<thead>
												<tr>
													<th>#</th>
													<th>{{ $t("content.cnameth") }}</th>
													<th>{{ $t("content.cnameen") }}</th>
													<th>{{ $t("content.docno") }}</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr class="row-search">
													<td></td>
													<td>
														<material-input v-model="nameThC" type="text"
															:label="t('content.cnameth')" />
													</td>
													<td>
														<material-input v-model="nameEnC" type="text"
															:label="t('content.cnameen')" />
													</td>
													<td>
														<material-input v-model="docNumberC" type="text"
															:label="t('content.docno')" />
													</td>
													<td>
														<material-button color="primary" variant="contain"
															class="rounded-circle ms-1" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnSearch"
															:disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
															@click="loadCustomerAfListApi">
															<i
																class="material-icons material-symbols-outlined">search</i>
														</material-button>
													</td>
												</tr>
												<tr v-for="(row, index) in customerlist" :key="index"
													@click="selectCus(row)">
													<td>{{ formatNumberString((currentPageC - 1) * perPageC + index
														+ 1)
													}}</td>
													<td>{{ row.nameTh }}</td>
													<td>{{ row.nameEn }}</td>
													<td colspan="2">{{ row.docNumber }}</td>
												</tr>
												<tr v-if="customerlist.length === 0">
													<td colspan="5" class="text-sm font-weight-normal">
														<p style="text-align: center">No Record Found</p>
													</td>
												</tr>
											</tbody>
										</table>
									</section>
								</div>
							</div>

							<div class="modal-footer">
								<pre></pre>
								<div style="display: flex; justify-content: flex-end">
									<ul v-show="customerlist.length > 0" class="pagination justify-content-end">
										<div class="project-container">
											<div class="example-one">
												<vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
													:items-per-page="perPageC" @click="onClickHandlerC" />
											</div>
										</div>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>


        <div id="reciveInfoModal" class="modal fade" tabindex="-1" aria-labelledby="reciveInfoModalLabel"
					aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.infofbank") }}</h4>
								<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
									id="closeModal">
									<i class="material-icons material-symbols-outlined">close</i>
								</button>
              </div>
              <div class="modal-body" v-if="receive !== null">
                <table class="table table-sm table-borderless">
                  <tbody>
                    <tr>
											<td>{{ $t("content.amount") }} :
												{{ formatNumberDecimalString(receive.amount) }}
											</td>

											<td>{{ $t("content.transferstatus") }} :
                        <span v-if="receive.transferStatus === 'INITIAL'">เริ่มต้น</span>
                        <span v-else-if="receive.transferStatus === 'IN_PROCESS'">กำลังดำเนินการ</span>
                        <span v-else-if="receive.transferStatus === 'COMPLETE'">สำเร็จ</span>
                        <span v-else-if="receive.transferStatus === 'FAILURE'">ล้มเหลว</span>
                        <span v-else-if="receive.transferStatus === 'CANCEL'">ยกเลิก</span>
                        <span v-else>{{ receive.transferStatus }}</span>
											</td>
										</tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>


    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { ref, reactive, inject, computed } from 'vue'
import { useI18n } from "vue-i18n"

import MaterialButton from "@/components/MaterialButton.vue"
import MaterialInput from "@/components/MaterialInput.vue"
import ExampleFive from "@/examples/ExampleOne";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'


import { useCustomerStore } from '@/stores/customer'
import { useOrchestrationStore } from '@/stores/orchestration'
import { useReceivAbletStore } from '@/stores/receivable'


const storecus = useCustomerStore()
const storeoc = useOrchestrationStore()
const storera = useReceivAbletStore()

const { t } = useI18n()
const swal = inject('$swal')


const btnApprove = computed(() => t("buttons.approve"))
const btnSearch = computed(() => t("buttons.sear"))
const btnDel = computed(() => t("buttons.remo"));

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const listoc = ref([]);
const start_date = ref(new Date(new Date().setHours(0, 0, 0, 0)));
const end_date = ref(new Date());
const tx_search = ref('');
const channel_search = ref('');
const transfer_search = ref('');
const receive = ref(null);
const channel_select = ref('');


const cusUid_search = ref('');
const cusName_search = ref('');
const customerlist = ref([])

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')




const key = JSON.parse(localStorage.getItem("shop_seleted"));

const onClickHandler = (page) => {
  updatePagination()
};

const onClickHandlerC = (page) => {
  updatePaginationC()
};

const checkChanel = async (val) => {
  currentPage.value = 1
  listoc.value = []
  totalRows.value = 0
  totalRows_s.value = 0
  channel_select.value = ''
  if (channel_search.value === 'SHOP') {
     channel_select.value = 'SHOP'
     await loadDataApi()
  } else {
    channel_select.value = 'LINE_LIFF'
    await loadDataLineApi()
  }
 }


const loadDataApi = async () => {
  let sd = ''
  let ed = ''
  let data = "";

  sd = moment(new Date(start_date.value)).format('YYYY-MM-DD')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DD')
  
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    shopUid: key.uid,
    cusUid:  cusUid_search.value,
    cusName:  '',
    txState:  tx_search.value,
    transferStatus:  transfer_search.value,
    refNumber:  '',
    paymentGroupUid: '',
    fromDate:  sd,
    toDate:  ed
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeoc.orchestrationListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listoc.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }
}


async function updatePagination() {
  listoc.value = []
  let sd = ''
  let ed = ''
  let data = "";

  sd = moment(new Date(start_date.value)).format('YYYY-MM-DD')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DD')
  
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    shopUid: key.uid,
    cusUid:  cusUid_search.value,
    cusName:  '',
    txState:  tx_search.value,
    transferStatus:  transfer_search.value,
    refNumber:  '',
    paymentGroupUid: '',
    fromDate:  sd,
    toDate:  ed
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeoc.orchestrationListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listoc.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }
}


const loadDataLineApi = async () => {
  let sd = ''
  let ed = ''
  let data = "";

  sd = moment(new Date(start_date.value)).format('YYYY-MM-DD')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DD')
  
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    shopUid: key.uid,
    cusUid:  cusUid_search.value,
    cusName:  '',
    paymentGroupUid: '',
    fromDate:  sd,
    toDate:  ed
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeoc.orchestrationAdminListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listoc.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }
}


async function updatePaginationLine() {
  listoc.value
  let sd = ''
  let ed = ''
  let data = "";

  sd = moment(new Date(start_date.value)).format('YYYY-MM-DD')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DD')
  
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    shopUid: key.uid,
    cusUid:  cusUid_search.value,
    cusName:  '',
    paymentGroupUid: '',
    fromDate:  sd,
    toDate:  ed
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeoc.orchestrationAdminListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listoc.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }
}


function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function cancelBtn() {
  start_date.value = new Date(new Date().setHours(0, 0, 0, 0));
  end_date.value = new Date();
  tx_search.value = ''
  channel_search.value = ''
  transfer_search.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  totalRows_s.value = ''
  currentPage.value = 1
  listoc.value = []

}



async function openDialogCus() {
	nameThC.value = ''
	nameEnC.value = ''
	docNumberC.value = ''
	cusUid_search.value = ''
	cusName_search.value = ''
	customerlist.value = []
	document.getElementById("searchNameCus").click();
}


async function selectCus(item) {
	cusUid_search.value = item.uid
	cusName_search.value = item.nameTh
	document.getElementById("closeModal").click();
}

async function loadCustomerAfListApi() {
	currentPageC.value = 1
	let data = "";
	data = {
		index: currentPageC.value - 1,
		size: perPageC.value,
		nameEn: nameEnC.value,
		nameTh: nameThC.value,
		docNumber: docNumberC.value

	};

	const payload = data;
	// console.log("payload : " + JSON.stringify(payload));
	const response = await storecus.searchCustomerFetch(payload);
	// console.log("loadCustomerListApi : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				let listd = response.data.data.list;
				customerlist.value = listd;
				totalRowsC.value = response.data.data.ext.total
				totalRows_sC.value = formatNumberString(totalRowsC.value)
			}
		}
	}
}


async function updatePaginationC() {
	customerlist.value = []
	let data = "";
	data = {
		index: currentPageC.value - 1,
		size: perPageC.value,
		nameEn: nameEnC.value,
		nameTh: nameThC.value,
		docNumber: docNumberC.value

	};
	const payload = data;
	// console.log("payload : " + JSON.stringify(payload));
	const response = await storecus.searchCustomerFetch(payload);
	// console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				customerlist.value = response.data.data.list;
				totalRowsC.value = response.data.data.ext.total
				totalRows_sC.value = formatNumberString(totalRowsC.value)
			}
		}
	}
}

async function receivableInfo(item, val) {
  receive.value = null
  let data = "";
  data = {
    uid: item.receivableUid
  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storera.receivAbleInfoFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        receive.value = response.data.data;
        if (val === 'view') {
          document.getElementById("detailModal").click();
        } else if (val === 'approve') {
          if (receive.value.transferStatus === 'COMPLETE') {
            // console.log("receivableInfo : " + JSON.stringify(receive.value));
            onCompleteDialog(item)
          } else { 
            swal("ไม่สามารถอนุมัติรายการนี้ได้", "", "error");
          }
        }
      }
    }
  }
}


async function onCompleteDialog(item) {
  swal({
    title: "ตรวจสอบรายการ",
    text: "คุณต้องการอนุมัติรายการนี้",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      if (channel_select.value !== 'SHOP') {
        onCompleteAdmin(item)
      } else {
        onComplete(item)
      }
    }
  });
}


async function deleteRowItems(item) {
  swal({
    title: "ลบรายการ",
    text: "คุณต้องการลบรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        onDeleteTx(item);
      }
    }
  });
}

async function onComplete(item) {
  let data = "";
  data = {
    uid: item.paymentGroupUid,
  };
  const payload = data;
  const response = await storeoc.manualCompletedFetch(payload);
  // console.log('completeStep : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function onCompleteAdmin(item) {
  let data = "";
  data = {
    uid: item.paymentGroupUid,
    shopUid: key.uid,
  };
  
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storeoc.manualCompletedAdminFetch(payload);
  // console.log('completeStep : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataLineApi()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function onDeleteTx(item) {
  let data = "";
  data = {
    uid: item.uid,
    shopUid: key.uid,
  };
  const payload = data;
  const response = await storeoc.deleteTxFetch(payload);
  // console.log('completeStep : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataLineApi()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


</script>

<style lang="scss" scoped>
.fs-14 {
  font-size: 0.875rem;
}

.loading-state {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>